import { axiosObj } from "./axios";
 
 
//Getting all tribe
export const getAllUnit = async (accessToken: string): Promise<any> => {
    const TribeByIdData = axiosObj.get(`/units/findAllLesson`, {
        headers: {
            Authorization : `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    });
    return (await TribeByIdData).data
};
 
//Getting all tribe
export const getAllUnitByOffset = async (offset: string, count: string, allRecord: boolean, accessToken: string): Promise<any> => {
    const offsetUnits = axiosObj.get(`/units?offset=${offset}&count=${count}&allRecord=${allRecord}`, {
        headers: {
            Authorization : `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    });
    return (await offsetUnits).data
};
 
//Getting all tribe
export const getAllUnitWithoutOffset = async (offset: string, count: string, accessToken: string): Promise<any> => {
    const offsetUnits = axiosObj.get(`/units?offset=${offset}&count=${count}`, {
        headers: {
            Authorization : `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        }
    });
    return (await offsetUnits).data
};
 
//Updating the tribe
export const getUnitByUnitId = async (unitId: string, accessToken: string): Promise<any> => {
    const updatedTribeResponse = axiosObj.get(`/units/findByUnitId/${unitId}`, {
        headers: {
            Authorization : `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });
    return (await updatedTribeResponse).data
};
 
//Updating the tribe
export const deleteUnitByID = async (unitId: string, accessToken: string): Promise<any> => {
    const updatedTribeResponse = axiosObj.delete(`/units/${unitId}`, {
        headers: {
            Authorization : `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });
    return (await updatedTribeResponse).data
};
 
export const getLessonByLessonID = async (lessonId: string, accessToken: string): Promise<any> => {
    const updatedTribeResponse = axiosObj.get(`/lessons/${lessonId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
        },
    });
    return (await updatedTribeResponse).data
};
 
//Search Tribe with offset limit and Count 
export const searchUnit = async (searchText: string, status: string, gradeId: string,  startDate: string | null, endDate: string | null, offset: string, count: string, ChallengeType: string, accessToken: string) => {
    const queryParams = new URLSearchParams();
 
    if (searchText) queryParams.append("name", searchText);
    if (status) queryParams.append("isActive", status);
    if (gradeId) queryParams.append("grade", gradeId)
    if (startDate) queryParams.append("start_date", startDate);
    if (endDate) queryParams.append("end_date", endDate);
    if(ChallengeType) queryParams.append("category", ChallengeType)
    queryParams.append("offset", offset);
    queryParams.append("count", count);
 
    const url = `units/searchUnitByFilter?${queryParams.toString()}`;
 
    try {
        const response = await axiosObj.get(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        });
 
        return response.data;
    } catch (error) {
        console.error("Error in searchTribe API:", error);
        throw error;
    }
};
 
 
 